$(document).on("click", ".js-mobile_nav_toggle", function(e){
    e.preventDefault();
    toggleBurger($(this));
    $(".js-mobile_nav").toggle(100);
})

$(document).on("click", ".js-mobile_search_open", function(e){
    e.preventDefault();
    $(".js-mobile_search_con").slideDown(100);
    $(".js-mobile_search_close").show();
    $(".js-mobile_search_open").hide();
})

$(document).on("click", ".js-mobile_search_close", function(e){
    e.preventDefault();
    $(".js-mobile_search_con").slideUp(100);
    $(".js-mobile_search_open").show();
    $(".js-mobile_search_close").hide();
})

$(document).on("click", ".js-mobile_search_start", function(e){
    e.preventDefault();
    toggleBurger($(this));
})

$(document).on("click", ".js-mobile_nav_link_sub_toggle", function(e){
    e.preventDefault();
    $(this).siblings(".js-mobile_nav_sub_toggle").trigger("click");
});

$(document).on("click", ".js-mobile_nav_sub_toggle", function(e){
    e.preventDefault();
    if($(this).hasClass("fa-plus")){
        $(this).removeClass("fa-plus").addClass("fa-minus");
        $(this).siblings(".js-mobile_nav_sub").slideDown(100);
    }else{
        $(this).removeClass("fa-minus").addClass("fa-plus");
        $(this).siblings(".js-mobile_nav_sub").slideUp(100);
        $(this).siblings(".js-mobile_nav_sub").find(".js-mobile_nav_sub").hide();
        $(this).siblings(".js-mobile_nav_sub").find(".js-mobile_nav_sub_toggle").removeClass("fa-minus").addClass("fa-plus");
    }
})